import { forwardRef } from '@chakra-ui/react';

import { Box, type BoxProps, Text } from '@frontend/components';

import { useTableStyles } from '../TableStylesContext';

export type TableTitleProps = BoxProps;

/**
 * A Table subcomponent to give the table a title.
 * - Place within the TableHeader.
 * - Wraps a Chakra-UI Text and responds to Table's size.
 */
export const TableTitle = forwardRef<TableTitleProps, 'div'>(
  ({ as = Text, children, ...restProps }: TableTitleProps, ref) => {
    const { title: titleStyles } = useTableStyles() ?? {};

    return (
      <Box ref={ref} as={as} __css={titleStyles} {...restProps}>
        {children}
      </Box>
    );
  },
);
TableTitle.displayName = 'TableTitle';
